export const UserLoginStatus = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  INACTIVE: 'inactive',
};

export const LoginTypes = {
  Mobile: 'mobile',
  MobileAppDeleted: 'mobile_app_deleted',
  Web: 'web',
};
